export const FRAMEWORK_TOGGLE_LEFTSIDEOPEN = 'FRAMEWORK_TOGGLE_LEFTSIDEOPEN'
export const FRAMEWORKTABS_ADD_TABITEM = 'FRAMEWORKTABS_ADD_TABITEM'
export const FRAMEWORKTABS_ACTIVE_TABITEM = 'FRAMEWORKTABS_ACTIVE_TABITEM'
export const FRAMEWORKTABS_UNACTIVE_TABITEM = 'FRAMEWORKTABS_UNACTIVE_TABITEM'
export const FRAMEWORK_TOPMENU_ACTIVE = 'FRAMEWORK_TOPMENU_ACTIVE'
export const FRAMEWORK_LAST_ACTIVE = 'FRAMEWORK_LAST_ACTIVE'
export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_MENU_TOGGLE = 'AUTH_MENU_TOGGLE'
export const AUTH_MENU_ITEMCLICK = 'AUTH_MENU_ITEMCLICK'
export const AUTH_BIND_ACCESSTOKEN = 'AUTH_BIND_ACCESSTOKEN'
export const AUTH_FLUSH_ACCESSTOKEN = 'AUTH_FLUSH_ACCESSTOKEN'
export const TABPANEL_BUILD_PARAMS = 'TABPANEL_BUILD_PARAMS'
export const AUTH_FLUSH_MENU = 'AUTH_FLUSH_MENU'
export const FRAMEWORK_TOGGLE_FIRSTLOAD = 'FRAMEWORK_TOGGLE_FIRSTLOAD'
export const FRAMEWORK_TOGGLE_TIPS = 'FRAMEWORK_TOGGLE_TIPS'


// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js